<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.5 7C5.567 7 4 8.567 4 10.5C4 12.433 5.567 14 7.5 14H14V16H7.5C4.46243 16 2 13.5376 2 10.5C2 7.46243 4.46243 5 7.5 5H14C16.2091 5 18 6.79086 18 9C18 11.2091 16.2091 13 14 13H8.5C7.11929 13 6 11.8807 6 10.5C6 9.11929 7.11929 8 8.5 8H14V10H8.5C8.22386 10 8 10.2239 8 10.5C8 10.7761 8.22386 11 8.5 11H14C15.1046 11 16 10.1046 16 9C16 7.89543 15.1046 7 14 7H7.5Z"
  />
</svg>
